import * as React from "react";
const SvgBookmark20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2 2h16v16.943l-8-5.714-8 5.714V2Zm2 2v11.057l6-4.286 6 4.286V4H4Z",
      clipRule: "evenodd"
    })
  );
export default SvgBookmark20Px;
